import { fg } from '@atlassian/jira-feature-gating';

const JiraAiShowHumanSupervisorAvatarRelayProvider = {
	get(): boolean {
		return fg('jira_ai_show_human_supervisor_avatar');
	},
};

export default JiraAiShowHumanSupervisorAvatarRelayProvider;
